import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import BlogList, { BlogListProps } from '@/features/blogs/pages/BlogList'
import { getBlogs } from '@/features/blogs/api/getBlogs'
import { DEFAULT_LOCALE } from '@/lib/localization/constants'

export async function getServerSideProps(
  ctx: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<BlogListProps>> {
  const { query, locale = DEFAULT_LOCALE } = ctx

  const { blogs, response } = await getBlogs(locale, {
    page: query.page
      ? parseInt(Array.isArray(query.page) ? query.page.join('') : query.page)
      : 1,
    per: 12,
    search: (query.search as string) || undefined,
  })

  return {
    props: {
      blogs,
      ...(response && {
        currentPage: parseInt(response.data.meta.page),
        totalPage:
          Math.ceil(response.data.meta.total / response.data.meta.per_page) ||
          1,
      }),
      ...(await serverSideTranslations(locale, ['common'])),
    },
    notFound: !blogs || undefined,
  }
}

export default BlogList
